"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitivityHeaderFormatterFactory = exports.DataQualityIconHeaderCertificationFormatterFactory = exports.DataQualityIconHeaderFormatterFactory = void 0;
const tslib_1 = require("tslib");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelIcons_1 = require("../../labels/LabelIcons");
// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
const IconHeader = (0, vizportalclient_common_components_1.divWithStyle)('IconCell', {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace - 1,
    paddingRight: widgets_1.TabStyles.Spacing.MediumSpace,
});
function IconHeaderFormatter() {
    return (react_1.default.createElement(IconHeader, null,
        react_1.default.createElement(LabelIcons_1.WarningColumnHeaderIcon, null)));
}
function CertificationIconHeaderFormatter() {
    return (react_1.default.createElement(IconHeader, null,
        react_1.default.createElement(catalog_icons_1.SvgCertifiedIconColumnHeader, { "aria-label": catalog_messages_1.Messages.Certification() })));
}
exports.DataQualityIconHeaderFormatterFactory = react_1.default.createFactory(IconHeaderFormatter);
exports.DataQualityIconHeaderCertificationFormatterFactory = react_1.default.createFactory(CertificationIconHeaderFormatter);
exports.SensitivityHeaderFormatterFactory = react_1.default.createFactory(IconHeaderFormatter);
//# sourceMappingURL=LabelIconHeaderFormatFactory.js.map